"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _quotaActions = require("settings-ui-app/modules/quotas/actions/quotaActions");

var _actions = require("settings-ui-sdk/Owners/actions");

var _pipelineActions = require("settings-ui-app/modules/quotas/actions/pipelineActions");

var _alertActions = require("settings-ui-app/modules/quotas/actions/alertActions");

var _Constants = require("settings-ui-app/modules/quotas/Constants");

var _immutable = require("immutable");

var initialState = (0, _immutable.List)();

function createError(error) {
  return (0, _immutable.Map)({
    id: _I18n.default.moment().unix(),
    message: _I18n.default.text("sales.quotas.errors." + error),
    timestamp: _I18n.default.moment().unix(),
    titleText: 'Error',
    type: 'danger'
  });
}

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _alertActions.DELETE_ALERT_ACTION_TYPE:
      state = state.filter(function (curAction) {
        return curAction.get('id') !== action.payload;
      });
      break;

    case _quotaActions.GetQuotasActionTypes.FAILURE:
      state = state.unshift(createError(_Constants.ERRORS.GET_QUOTAS));
      break;

    case _quotaActions.SaveQuotasActionTypes.FAILURE:
      state = state.unshift(createError(_Constants.ERRORS.SAVE_QUOTAS));
      break;

    case _quotaActions.DeleteQuotasActionTypes.FAILURE:
      state = state.unshift(createError(_Constants.ERRORS.DELETE_QUOTAS));
      break;

    case _actions.FetchOwnersActionTypes.FAILURE:
      state = state.unshift(createError(_Constants.ERRORS.GET_OWNERS));
      break;

    case _pipelineActions.GetPipelinesActionTypes.FAILURE:
      state = state.unshift(createError(_Constants.ERRORS.GET_PIPELINES));
      break;

    default:
      break;
  }

  return state;
};

exports.default = _default;
module.exports = exports.default;